import { useCallback, useState } from "react";
import { api } from "@/api";
import { useNavigate } from "react-router-dom";
import useErrorHandling from "@/hooks/useErrorHandling";
import { toast } from "react-toastify";
import { OfficeForm, OfficeFormData } from "@/app/components/office/OfficeForm";
import { ModalError } from "@/app/components/modals/modalBuilder";

export function CreateOfficePage() {
  const navigate = useNavigate();
  const handleError = useErrorHandling();

  const [modalErrors, setModalErrors] = useState<ModalError[]>([]);

  const onSubmit = useCallback(
    (data: OfficeFormData) => {
      api.offices
        .create({
          display_name: data.display_name,
          office_type: Number(data.office_type),
          area: data.area,
          floor: data.floor,
          office_lock: data.office_lock || undefined,
          price: data.price,
          room_count: data.room_count,
          location: Number(data.location),
          commissioning_date: data.commissioning_date + "T00:00:00",
          workplace_count: data.workplace_count,
          ceiling_height: data.ceiling_height,
          description: data.description,
          finishing: data.finishing,
          main_photo: data.main_photo || undefined,
          additional_photos: data.additional_photos,
          min_period: data.min_period,
          public: data.public,
          features: data.features,
        })
        .then(() => {
          toast.success("Офис успешно создан");
          navigate("/dashboard/offices");
        })
        .catch((err) => {
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErrors(parsedErrors || []);
          toast.error(errorMessage);
        });
    },
    [navigate, handleError, setModalErrors],
  );

  return (
    <>
      <h1 className="text-xl font-bold mb-4">Создание офиса</h1>
      <OfficeForm onSubmit={onSubmit} modalErrors={modalErrors} />
    </>
  );
}
